import { render, staticRenderFns } from "./UsersOverviewTable.vue?vue&type=template&id=54ae7618"
import script from "./UsersOverviewTable.vue?vue&type=script&lang=js"
export * from "./UsersOverviewTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports